import reducer, { rfpSlice } from './slice';

export const { reset, setMode, setRfpData } = rfpSlice.actions;

export default reducer;
